import { render, staticRenderFns } from "./OrderAnalyze.vue?vue&type=template&id=99dae024&scoped=true&"
import script from "./OrderAnalyze.vue?vue&type=script&lang=js&"
export * from "./OrderAnalyze.vue?vue&type=script&lang=js&"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=99dae024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dae024",
  null
  
)

export default component.exports